// Button group positions

export const HUD_POSITION_TOP = 'TOP';
export const HUD_POSITION_TOP_RIGHT = 'TOP_RIGHT';
export const HUD_POSITION_RIGHT = 'RIGHT';
export const HUD_POSITION_BOTTOM_RIGHT = 'BOTTOM_RIGHT';
export const HUD_POSITION_BOTTOM = 'BOTTOM';
export const HUD_POSITION_BOTTOM_LEFT = 'BOTTOM_LEFT';
export const HUD_POSITION_LEFT = 'LEFT';
export const HUD_POSITION_TOP_LEFT = 'TOP_LEFT';
export const HUD_POSITION_CENTER = 'CENTER';

/*
==============================================================================
DEFAULT BUTTON SETUP : Button id, costume and position data for button groups
==============================================================================


// Default button structure

{
  id: 'sound',            // id togive the button for handling in callback
  position: 'TOP_RIGHT',  // where to anchor to screen, see button group positions above for available positions
  costume: 'sound',       // what costume to use , if no costume id - then the costume data needs to be added here instead

  // costume is optional for reusability, but you can always dump the up/over/down frames instead

}

    reason for costume seperation :)

    These two are seperated as you may want to reuse the texture but on a 'different' button ( id / position )
    Also a state may wish to use the auto button funcationality, but bounce of a unique id for conditional logic ( see example in Suicase state with back button )


*/

export const DEFAULT_BUTTONS = {
  sound: { id: 'sound', customclass: 'SoundButton', position: 'TOP_RIGHT' },
  suitcase: { id: 'suitcase', customclass: 'Suitcase', position: 'BOTTOM_LEFT' },
  boomlogo: { id: 'boomlogo', customclass: 'Boom', position: 'BOTTOM_LEFT' },
  play_game: { id: 'playgame', costume: 'playgame', position: 'CENTER' },
  question: { id: 'question', costume: 'question', position: 'TOP_LEFT' },
  backtohome: { id: 'backtohome', costume: 'home', position: 'TOP_LEFT' },
  backtoworld: { id: 'backtoworld', costume: 'back', position: 'TOP_LEFT' },
  prevpage: { id: 'prevpage', costume: 'prev', position: 'LEFT' },
  nextpage: { id: 'nextpage', costume: 'next', position: 'RIGHT' },
  close: { id: 'close', costume: 'close' },
  pause: { id: 'pause', costume: 'pause', position: 'TOP_RIGHT' },
  skip: { id: 'skip', costume: 'rightarrow', position: 'BOTTOM_RIGHT' },
  pauseworldmap: { id: 'pauseworldmap', costume: 'pauseworldmap', position: 'CENTER' },
  pausereplay: { id: 'pausereplay', costume: 'pausereplay', position: 'CENTER' },
  resume: { id: 'resume', costume: 'playgame', position: 'CENTER' },

  // using wrong graphic, don't have design files at home :)

  suitcaseback: { id: 'suitcaseback', costume: 'back', position: 'TOP_LEFT' },
  home: { id: 'home', costume: 'home', position: 'TOP_LEFT' },
  howtoplay: { id: 'howtoplay', costume: 'question', position: 'BOTTOM_RIGHT' },
};

/*
==============================================================================

    DEFAULT COSTUME : button texture and frame states data

    I have split this out as was finding using same costue for different buttons
    This happens, this way we can reuse data :)

    Costume structure

    {
    texture : '' : optional, determines what spritesheet to use - defaults to 'buttons_sprite'
    up, over, down - frames to use :)
}

==============================================================================
*/

export const DEFAULT_COSTUMES = {
  home: {
    up: 'btn_home_white',
    over: 'btn_home_pink',
    down: 'btn_home_pink',
  },
  pause: {
    up: 'btn_pause_white',
    over: 'btn_pause_pink',
    down: 'btn_pause_pink',
  },
  soundon: {
    up: 'btn_soundon_white',
    over: 'btn_soundon_pink',
    down: 'btn_soundon_pink',
  },
  soundoff: {
    up: 'btn_soundoff_white',
    over: 'btn_soundoff_pink',
    down: 'btn_soundoff_pink',
  },
  playgame: {
    up: 'btn_mainplay_white',
    over: 'btn_mainplay_pink',
    down: 'btn_mainplay_pink',
  },
  question: {
    up: 'btn_help_white',
    over: 'btn_help_pink',
    down: 'btn_help_pink',
  },
  back: {
    up: 'btn_arrowleft_white',
    over: 'btn_arrowleft_pink',
    down: 'btn_arrowleft_pink',
  },
  close: {
    up: 'btn_close_pink',
    over: 'btn_close_white',
    down: 'btn_close_white',
  },
  prev: {
    up: 'btn_prev_white',
    over: 'btn_prev_pink',
    down: 'btn_prev_pink',
  },
  next: {
    up: 'btn_next_white',
    over: 'btn_next_pink',
    down: 'btn_next_pink',
  },
  rightarrow: {
    up: 'btn_arrowright_pink',
    over: 'btn_arrowright_white',
    down: 'btn_arrowright_white',
  },
  rightarrow_med: {
    up: 'btn_arrowright_med_pink',
    over: 'btn_arrowright_med_white',
    down: 'btn_arrowright_med_white',
  },

  play_video_button: {
    up: 'btn_video_pink',
    over: 'btn_video_white',
    down: 'btn_video_white',
  },

  phone_button: {
    up: 'btn_selfie_pink',
    over: 'btn_selfie_white',
    down: 'btn_selfie_white',
  },
  present_button: {
    up: 'btn_souvenir_pink',
    over: 'btn_souvenir_white',
    down: 'btn_souvenir_white',
  },
  food_game_button: {
    up: 'btn_foodgame_pink',
    over: 'btn_foodgame_white',
    down: 'btn_foodgame_white',
  },
  mini_game_button: {
    up: 'btn_chasegame_pink',
    over: 'btn_chasegame_white',
    down: 'btn_chasegame_white',
  },
  world_button: {
    up: 'btn_world_pink',
    over: 'btn_world_white',
    down: 'btn_world_white',
  },
  poll_button: {
    up: 'btn_poll_pink',
    over: 'btn_poll_white',
    down: 'btn_poll_white',
  },
  pauseworldmap: {
    up: 'btn_worldmap_white',
    over: 'btn_worldmap_pink',
    down: 'btn_worldmap_pink',
  },
  pausereplay: {
    up: 'btn_restart_white',
    over: 'btn_restart_pink',
    down: 'btn_restart_pink',
  },
  like: {
    up: 'btn_like_white',
    over: 'btn_like_pink',
    down: 'btn_like_pink',
  },
  print: {
    up: 'btn_print_pink',
    over: 'btn_print_white',
    down: 'btn_print_white',
  },
};

/*
==============================================================================
Couple of handy methods to pull the data from below :)
==============================================================================
*/
export const GetDefaultButtonData = (id) => {
  const data = DEFAULT_BUTTONS[id];
  if (data.costume) {
    return { ...data, ...GetDefaultButtonCostume(data.costume) };
  }
  return data;
};

export const GetDefaultButtonCostume = (id) => {
  return DEFAULT_COSTUMES[id];
};



// WEBPACK FOOTER //
// ./js/app/ui/hud/HudConstants.js